<template>
  <!-- //年金 -->
  <div>
    <!-- 規劃年金 -->
    <div class="row mt_16"><div class="col create_title">規劃年金</div></div>
    <div class="form-group d-flex align-items-end mt_20">
      <!-- 年金給付年齡 -->
      <div class="d-flex align-items-center mr_8">
        <div style="line-height: 40px" class="mr_4">
          <strong>年金給付年齡:</strong>
        </div>
        <div class="position-relative">
          <div class="d-flex align-items-center">
            <input
              id="event_dueage"
              type="tel"
              maxlength="3"
              class="form-control mr_2"
              style="width: 7em"
              :class="{ 'is-invalid': errors.has('dueage') }"
              :data-vv-name="'dueage'"
              v-validate="`required|dueage`"
              data-vv-as="年金給付年齡"
              @input="
                ageFormat(productDataScope, 'dueage');
                validateAll();
                resetPaymethod();
              "
              v-model.trim="productDataScope.dueage"
              :placeholder="`${
                $store.getters.MfEditing.insured.insured_age * 1 +
                (productDataScope.FEATURE_DATA.acc_year1 || 0) * 1
              }~${productDataScope.FEATURE_DATA.anty_ceil_age || 99}`"
            />
          </div>
        </div>
        <span>歲</span>
      </div>
    </div>
    <div class="form-group d-flex align-items-end mt_20">
      <!-- 年金給付方式 -->
      <div class="d-flex align-items-center mr_16">
        <label><strong>年金給付方式:</strong></label>
        <select
          class="form-control ml_4 mr_2"
          style="width: 8rem"
          :id="'anty_pay'"
          v-validate="`required`"
          data-vv-as="年金給付方式"
          data-vv-name="anty_pay"
          v-model="productDataScope.anty_pay"
          @change="anty_pay_changeHandler()"
        >
          <option
            v-for="item in anty_pay_list"
            :key="item.paraval"
            :value="item.paraval"
          >
            {{ item.paradetlno }}
          </option>
        </select>
      </div>
      <div class="position-relative d-flex">
        <div
          class="notice-top text-red"
          style="text-align: left; padding-left: 5.5em"
        >
          年金給付選擇分期給付，方能選擇預定利率與年金保證期間
          <br />
          <span v-if="show_cur_y_rate_msg"
            >{{ str_date_y }}年{{ str_date_m }}月最新年金分期預定利率：{{
              cur_y_rate
            }}%，僅作為預定利率設定參考值</span
          >
        </div>
        <!-- 預定利率 -->
        <div class="d-flex align-items-center mr_14">
          <label><strong>預定利率:</strong></label>
          <select
            class="form-control ml_4 mr_2"
            style="width: 6rem"
            :id="'interest_rate'"
            v-validate="productDataScope.anty_pay == '2' ? 'required' : ''"
            data-vv-as="預定利率"
            data-vv-name="defaultrate"
            v-model="productDataScope.defaultrate"
            :disabled="productDataScope.anty_pay != '2'"
            :class="{ 'is-invalid': errors.has('defaultrate') }"
            @change="$validator.validate('defaultrate')"
          >
            <option value="" disabled>請選擇</option>
            <option
              v-for="option in defaultrate_list"
              :key="option"
              :value="option"
            >
              {{ option }}
            </option></select
          >%
        </div>
        <!-- 年金保證期間 -->
        <div class="d-flex align-items-center mr_16">
          <label><strong>年金保證期間:</strong></label>
          <select
            class="form-control ml_4 mr_2"
            style="width: 6rem"
            :id="'annuity_prod'"
            v-validate="
              productDataScope.anty_pay == '2' ? 'required|duetime' : ''
            "
            data-vv-as="年金保證期間"
            data-vv-name="duetime"
            v-model="productDataScope.duetime"
            :disabled="productDataScope.anty_pay != '2'"
            :class="{ 'is-invalid': errors.has('duetime') }"
            @change="$validator.validate('duetime')"
          >
            <option value="" disabled>請選擇</option>
            <option
              v-for="option in annuity_prod_list"
              :key="option"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
          <strong>年</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import { Validator } from "vee-validate";
export default {
  props: ["productDataScope", "mainIndex"],
  mixins: [mf_Mixin],
  data() {
    return {
      anty_pay_list: [],
      defaultrate_list: [], //預定利率
      annuity_prod_list: [], //年金保證期間:
      str_date_y: null, //查詢起日(年)
      str_date_m: null, //查詢起日(月)
      cur_y_rate: null, //當次的年利率
      show_cur_y_rate_msg: null,
    };
  },
  computed: {
    PRODUCT_FEATURE_DATA() {
      return this.productDataScope.FEATURE_DATA;
    },
    amt_formatVal() {
      if (this.productDataScope.FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.productDataScope.FEATURE_DATA.amt_unit);
      }
    },
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.$bus.on("event_dueage", function (message) {
      if (message == undefined || message == null || message == "") {
        document
          .getElementById("event_dueage")
          .setAttribute("class", "form-control is-invalid mr_2");
      }
    });
    this.$once("hook:destroyed", () => {
      this.$bus.off("event_dueage");
    });
  },
  methods: {
    init() {
      this.anty_pay_list = this.$paragrpno.anty_pay;
      let annuity_prod = this.PRODUCT_FEATURE_DATA.annuity_prod || "";
      this.annuity_prod_list = annuity_prod.split(",");
      let defaultrate_list = [];
      for (let i = 0; i <= 400; i += 25) {
        defaultrate_list.push((i / 100).toFixed(2));
      }
      this.defaultrate_list = defaultrate_list;
      //預設值
      if (this.productDataScope.defaultrate || this.productDataScope.duetime) {
        this.productDataScope.anty_pay = "2";
      } else {
        this.productDataScope.anty_pay = this.anty_pay_list[0].paraval;
      }
      this.productDataScope.defaultrate =
        this.productDataScope.defaultrate || "";
      this.productDataScope.duetime = this.productDataScope.duetime || "";
      this.initValidator();
      //取得最新預定利率
      this.$mfAPI
        .MFA1_0101__getDTAKC006({
          prod_id: this.productDataScope.prod_id,
        })
        .then((res) => {
          this.str_date_y = res.str_date_y;
          this.str_date_m = res.str_date_m;
          this.cur_y_rate = (res.cur_y_rate / 1).toFixed(2);
          this.show_cur_y_rate_msg = true;
        })
        .catch(() => {
          this.show_cur_y_rate_msg = false;
        });
    },
    initValidator() {
      Validator.extend(`dueage`, {
        getMessage: "",
        validate: (value) => {
          let intValue = value * 1;
          console.log("XCWEREWRWE", intValue);
          //   下限：被保人保險年齡 加上 mfm00100.acc_year1
          let floor =
            this.$store.getters.MfEditing.insured.insured_age * 1 +
            (this.productDataScope.FEATURE_DATA.acc_year1 || 0) * 1;
          // 　上限：mfm00100.anty_ceil_age
          let ceil = this.productDataScope.FEATURE_DATA.anty_ceil_age || 99;
          let totalCompare =
            parseInt(this.productDataScope.dueage) +
              parseInt(this.productDataScope.duetime) >
            parseInt(this.PRODUCT_FEATURE_DATA.pol_period);
          let polEndageCompare = true;
          if (
            this.productDataScope.pol_endage != undefined &&
            this.productDataScope.pol_endage != "" &&
            this.productDataScope.pol_endage != null
          ) {
            if (
              parseInt(intValue) < parseInt(this.productDataScope.pol_endage)
            ) {
              polEndageCompare = false;
            }
          }
          return (
            intValue <= ceil &&
            intValue >= floor &&
            !totalCompare &&
            polEndageCompare
          );
        },
      });
      Validator.extend(`duetime`, {
        getMessage: "",
        validate: () => {
          let totalCompare =
            parseInt(this.productDataScope.dueage) +
              parseInt(this.productDataScope.duetime) >
            parseInt(this.PRODUCT_FEATURE_DATA.pol_period);
          if (totalCompare) {
            this.$toast.info({
              title:
                "年金給付年齡 + 年金保證期間不得超過" +
                this.PRODUCT_FEATURE_DATA.pol_period +
                "年!",
            });
          }
          return !totalCompare;
        },
      });
    },
    anty_pay_changeHandler() {
      if (this.productDataScope.anty_pay != "2") {
        this.productDataScope.defaultrate = "";
        this.productDataScope.duetime = "";
      }
      this.$validator.reset();
      this.$forceUpdate();
    },
    async validateAll() {
      //檢核上方輸入框與投資比例分配
      let VaildInput = await this.$validator.validateAll();
      return VaildInput;
    },
    resetPaymethod() {
      if (this.productDataScope.paymethod) {
        // 此原件為共用元件，版型五、六都有用到，但版型六不會有新增繳費方式(paymethod)，但商品儲存時會產出paymethod={}，故多加此判斷
        if (this.productDataScope.paymethod !== "{}") {
          this.$mfNotice(
            "修改年金給付年齡,若有輸入的不定期保費將全部清除,是否仍要修改?",
            () => {
              this.productDataScope.paymethod = null;
              this.productDataScope.temp__paymethod = null;
            },
            true,
            () => {
              this.productDataScope.dueage = this.productDataScope.dueage_tmp;
              this.$validator.reset();
            },
            "確定清除"
          );
        }
      }
    },
    //比對選項及預設選項排序取得預設選項
    pickDefault(pre_definedable, preference) {
      if (!Array.isArray(pre_definedable) || pre_definedable.length === 0)
        return null;
      const set = new Set(pre_definedable);
      for (const p of preference) {
        if (set.has(p)) return p;
      }
      // 如果沒有比對到可用選項則預設選項第一個可用選項
      return pre_definedable[0];
    },
  },
  watch: {
    anty_pay_list: {
      immediate: false,
      handler(val) {
        if (!this.productDataScope.anty_pay) {
          //比對取得年金給付方式預設值，若為單一選項，則預帶該選項，若有一個選項以上則預帶「一次給付」
          var pre_defined_anty_pay = ["1", "2"];
          var default_anty_pay = this.pickDefault(
            this.anty_pay_list.map((item) => item.paraval),
            pre_defined_anty_pay
          );
          //設定年金給付方式預設值
          this.productDataScope.anty_pay = default_anty_pay;
        }
      },
    },
  },
};
</script>

<style></style>
